import React, { useState, useEffect } from 'react';
import { 
  Baby, Droplets, Video, ShieldCheck, Activity, Wind, X, 
  Stethoscope, Thermometer, Scissors, FlaskConical, 
  Heart, Building2, CheckCircle2, AlertTriangle, 
  Flame, Waves, Anchor, Biohazard, UserRound, 
  Search, Crosshair, Zap, AlertCircle, Star
} from 'lucide-react';
import Navbar from '../Navbar/Navbar';
import FooterSection from '../FooterSection/FooterSection';
import QuickAccess from '../QuickAccess/QuickAccess';
import './TreatmentsPage.css';
import DoctorName from '../DoctorName/DoctorName';

const TreatmentsPage = () => {
  const [selectedTreatment, setSelectedTreatment] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const treatments = [
   { 
  id: 1, 
  title: "Kasık Fıtığı", 
  icon: <Baby size={32} />, 
  color: "#4FBDBA", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda kasık fıtığı, karın içi organların (genellikle bağırsakların veya kız çocuklarında yumurtalıkların) 
        kasık kanalındaki bir açıklıktan dışarı doğru sarkmasıdır. Hidroselin aksine, kasık fıtığının kendiliğinden 
        geçme ihtimali yoktur.
      </p>

      <h4>Belirtiler: Nasıl Anlaşılır?</h4>
      <ul>
        <li>Kasık bölgesinde veya testis torbasında ıkınma, ağlama ve öksürme ile belirginleşen şişlik.</li>
        <li>Çocuk sakinleştiğinde veya uyuduğunda kaybolan veya küçülen yumuşak kütle.</li>
      </ul>

      <h4>Takip ve Tedavi: Neden Beklenmez?</h4>
      <p>
        <strong>Kendiliğinden İyileşmez:</strong> Kasık fıtığı, hidrosel gibi zamanla kapanmaz; 
        teşhis konulduğu anda cerrahi planlanmalıdır.
      </p>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', margin: '20px 0', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>Boğulmuş Fıtık Riski:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          En büyük risk, dışarı çıkan organın kanala sıkışması ve kan akımının bozulmasıdır (fıtık boğulması). 
          Bu, acil cerrahi gerektiren riskli bir durumdur.
        </p>
      </div>

      <h4>Cerrahi Planlama ve Süreç</h4>
      <ul>
        <li><strong>Zamanlama:</strong> Teşhis konulduktan sonra, uygun olan en kısa sürede (elektif şartlarda) ameliyat planlanır.</li>
        <li><strong>İşlem:</strong> Genellikle "günübirlik cerrahi" olarak yapılır. Kasık bölgesinden açılan küçük bir kesi ile fıtık kesesi onarılır.</li>
        <li><strong>İyileşme:</strong> Çocuklar ameliyattan birkaç saat sonra beslenmeye başlar ve aynı gün eve gönderilir. Dikişler genellikle cilt altında olduğu için pansuman gerektirmez.</li>
      </ul>

      <div className="emergency-note" style={{ background: '#f0f9ff', padding: '15px', borderRadius: '12px', border: '1px solid #bae6fd', marginTop: '20px' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>
          <AlertCircle size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Ne Zaman Acil Durumdur?
        </p>
        <p style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem' }}>
          Kasık bölgesindeki şişlik sertleşirse, kızarıklık oluşursa ve çocukta şiddetli kusma/karın ağrısı başlarsa 
          vakit kaybetmeden bir çocuk cerrahına başvurulmalıdır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 2, 
  title: "Hidrosel (Su Fıtığı)", 
  icon: <Droplets size={32} />, 
  color: "#FFB347", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Hidrosel (su fıtığı), testisleri çevreleyen zarlar arasında sıvı birikerek testis torbasının şişmesi durumudur. 
        Çocuklarda genellikle karın zarı ile torba arasındaki kanalın doğum sonrası açık kalması nedeniyle oluşur.
      </p>

      <div className="info-highlight-box" style={{ background: '#fff9db', padding: '15px', borderRadius: '12px', borderLeft: '5px solid #fab005', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#856404' }}>
          <strong>Kendiliğinden Geçebilir:</strong> Yeni doğanlarda görülen hidrosellerin büyük çoğunluğu 
          <strong> 1-2 yaşın</strong> sonuna kadar vücut tarafından emilerek kendiliğinden kaybolur.
        </p>
      </div>

      <p>
        <strong>İzlem:</strong> Bu süreçte cerrahi müdahale aceleci bir karar değildir; uzman bir çocuk cerrahı tarafından 
        periyodik kontrollerle takip edilmesi yeterlidir.
      </p>

      <h4>Ne Zaman Ameliyat Planlanmalı?</h4>
      <p>Aşağıdaki durumlarda cerrahi müdahale altın standarttır:</p>
      <ul>
        <li><strong>Yaş Sınırı:</strong> Hidrosel 1.5 - 2 yaşına kadar gerilememişse,</li>
        <li><strong>Fıtık Eşliği:</strong> Hidrosel ile birlikte kasık fıtığı saptanmışsa,</li>
        <li><strong>Değişken Şişlik:</strong> Şişlik gün içinde çok fazla artıp azalıyorsa (İrtibatlı Hidrosel).</li>
      </ul>

      <h4>Operasyon Hakkında</h4>
      <ul>
        <li><strong>Günübirlik İşlem:</strong> Ameliyat genellikle 30-40 dakika sürer ve çocuk aynı gün taburcu edilir.</li>
        <li><strong>Hızlı İyileşme:</strong> Kasık bölgesinden yapılan küçük bir kesi ile uygulanır; iyileşme süreci çok hızlıdır ve tekrarlama riski oldukça düşüktür.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>UNUTMAYIN:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Hidrosel tedavisinde <strong>iğne ile sıvı boşaltma yöntemi</strong> çocuklarda uygulanmaz ve önerilmez. 
          Tek kesin çözüm cerrahi onarımdır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 3, 
  title: "İnmemiş Testis", 
  icon: <Activity size={32} />, // İkonu içeriğe daha uygun olması için Video'dan Activity'e çektim ama Video kalsın istersen değiştirebilirsin
  color: "#7ED957", 
  longDesc: (
    <div className="treatment-details">
      <p>
        İnmemiş testis, bebeğin anne karnındaki gelişimi sırasında testislerin torbaya (skrotum) inme yolculuğunu 
        tamamlayamaması ve karın içinde veya kasık kanalında takılı kalmasıdır.
      </p>

      <h4>Takip Süreci ve Zamanlama</h4>
      <ul>
        <li><strong>İlk 6 Ay Beklenebilir:</strong> Bebek doğduğunda testisler yerinde değilse, ilk 6 aya kadar kendiliğinden inme ihtimali vardır.</li>
        <li><strong>Kritik Eşik:</strong> 6. aydan sonra testisin kendiliğinden inme olasılığı çok düşüktür.</li>
        <li><strong>İdeal Tedavi Aralığı:</strong> Testislerin torbadaki daha serin ortama ihtiyacı vardır. Bu nedenle, tedavinin en geç <strong>6 ay ile 12 ay arasında</strong> tamamlanması önerilir.</li>
      </ul>

      <h4>Neden Tedavi Edilmelidir?</h4>
      <p>Testislerin torba dışında (daha sıcak bir ortamda) kalması ileride şu risklere yol açabilir:</p>
      <ul>
        <li><strong>Kısırlık Riski:</strong> Testis yapısının bozulması sonucu sperm kalitesinin düşmesi.</li>
        <li><strong>Tümör Riski:</strong> Erken müdahale riski tamamen yok etmese de, testisin elle muayene edilebilir hale gelmesini sağlayarak erken tanıyı kolaylaştırır.</li>
        <li><strong>Fıtık Eşliği:</strong> İnmemiş testis vakalarına genellikle kasık fıtığı da eşlik eder.</li>
      </ul>

      <h4>Cerrahi Planlama (Orşidopeksi)</h4>
      <ul>
        <li><strong>Operasyon:</strong> Testis cerrahi olarak serbestleştirilir ve torba içine indirilerek sabitlenir.</li>
        <li><strong>Süreç:</strong> Genellikle günübirlik bir işlemdir; çocuk aynı gün taburcu olur.</li>
      </ul>

      <div className="info-box" style={{ background: '#f0fdf4', padding: '15px', borderRadius: '12px', border: '1px solid #bbf7d0', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#166534' }}>
          <strong>Utangaç (Retraktil) Testis:</strong> Bu durum gerçek inmemiş testis ile karıştırılmamalıdır. 
          Soğuk veya dokunma ile yukarı kaçan ancak elle rahatça torbaya indirilebilen testisler genellikle 
          cerrahi gerektirmez, <strong>ama dikkatli takip gerektirir.</strong>
        </p>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ HATIRLATICI:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          İnmemiş testis tedavisi için <strong>"ergenliğe kadar bekleyelim"</strong> düşüncesi tıbben yanlıştır. 
          Erken teşhis ve tedavi, testisin sağlıklı gelişimi için kritiktir.
        </p>
      </div>
    </div>
  )
},
    { 
  id: 4, 
  title: "Sünnet ve Yenidoğan Sünneti", 
  icon: <ShieldCheck size={32} />, 
  color: "#6C5CE7", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Sünnet, penis başını örten deri katmanının (prepusyum) cerrahi olarak çıkarılması işlemidir. 
        Günümüzde sünnet sadece dini veya kültürel bir gelenek değil, aynı zamanda önemli tıbbi faydaları 
        olan bir cerrahi müdahale olarak kabul edilmektedir.
      </p>

      <h4>Neden Yenidoğan Sünneti? (Avantajları)</h4>
      <p>Bebeğinizin ilk günlerinde yapılan sünnetin diğer yaş gruplarına göre birçok avantajı vardır:</p>
      <ul>
        <li><strong>Hızlı İyileşme:</strong> Yenidoğan bebeklerde hücre yenilenmesi çok hızlıdır. Yara iyileşmesi genellikle 2-3 gün içinde tamamlanır.</li>
        <li><strong>Düşük Enfeksiyon Riski:</strong> İlk bir yıl içindeki idrar yolu enfeksiyonu riskini yaklaşık 10 kat azaltır. Bu durum, özellikle böbrek sağlığı açısından kritiktir.</li>
        <li><strong>Psikolojik Konfor:</strong> Bebek bu dönemi hatırlamaz; dolayısıyla sünnet korkusu, genel anestezi kaygısı ve cerrahi travma yaşanmaz.</li>
        <li><strong>Lokal Anestezi Yeterliliği:</strong> Genel anesteziye gerek kalmadan, sadece bölgesel uyuşturucu kremler veya enjeksiyonlarla işlem konforlu bir şekilde tamamlanır.</li>
        <li><strong>Bakım Kolaylığı:</strong> Bebek henüz hareketlenmediği ve dönmeye başlamadığı için işlem sonrası pansuman ve koruma çok daha kolaydır. Anne sütü, içerdiği faktörlerle iyileşmeyi hızlandırır.</li>
      </ul>

      <h4>Sünnetin Sağlık Üzerindeki Diğer Faydaları</h4>
      <ul>
        <li><strong>Hijyen:</strong> Sünnet derisi altında biriken ve enfeksiyona yol açabilen salgıların (smegma) oluşmasını engeller.</li>
        <li><strong>Fimozis Önlenmesi:</strong> Sünnet derisinin geriye çekilemeyecek kadar dar olması (fimozis) ve buna bağlı idrar yapma zorluklarını ortadan kaldırır.</li>
        <li><strong>Gelecek Sağlığı:</strong> İlerleyen yaşlarda penis kanseri riskini ve bazı cinsel yolla bulaşan hastalıkların geçiş riskini önemli ölçüde azaltır.</li>
      </ul>

      <h4>Ne Zaman Yapılmamalı?</h4>
      <p>Aşağıdaki durumlarda sünnet, uzman bir çocuk cerrahı tarafından değerlendirilene kadar ertelenmelidir:</p>
      <ul>
        <li><strong>Peygamber Sünneti (Hipospadias):</strong> İdrar deliğinin normal yerinde olmaması. Bu durumda sünnet derisi ileride yapılacak onarım ameliyatı için kullanılacaktır.</li>
        <li><strong>Prematüre veya Hasta Bebekler:</strong> Bebek genel sağlığına kavuşana kadar beklenmelidir.</li>
        <li><strong>Kanama Eğilimi:</strong> Ailede kan hastalığı öyküsü varsa gerekli testler yapılmadan işleme başlanmamalıdır.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '10px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Sünnet bir <strong>"operasyon"</strong>dur ve mutlaka steril şartlarda, bu konuda uzman bir <strong>Çocuk Cerrahı</strong> tarafından yapılmalıdır. 
          Uygun olmayan koşullarda yapılan işlemler kalıcı şekil bozukluklarına veya ciddi enfeksiyonlara yol açabilir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 5, 
  title: "Testis ve Over Torsiyonu", 
  icon: <Activity size={32} />, 
  color: "#F06292", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Torsiyon, testisin veya yumurtalığın kendi etrafında dönerek kendi kan akımını kesmesidir. 
        Bu durum, organın beslenmesini durdurduğu için <strong>dakikalar ve saatler içinde</strong> kalıcı hasara yol açabilir.
      </p>

      <h4>Testis Torsiyonu (Erkek Çocuklarda)</h4>
      <ul>
        <li><strong>Belirtiler:</strong> Testis torbasında (skrotum) ani başlayan şiddetli ağrı, şişlik, kızarıklık ve bazen mide bulantısı/kusma.</li>
        <li><strong>Kritik Zaman:</strong> İlk <strong>6 saat</strong> altın saattir. Bu süre zarfında müdahale edilirse testisin kurtarılma şansı çok yüksektir.</li>
        <li><strong>Tedavi:</strong> Acil cerrahi ile testis döndürülür ve tekrar dönmemesi için torbaya sabitlenir.</li>
      </ul>

      <h4>Over Torsiyonu (Kız Çocuklarında)</h4>
      <ul>
        <li><strong>Belirtiler:</strong> Alt karın bölgesinde (kasıklarda) ani başlayan, şiddetli ve genellikle tek taraflı sancı. Beraberinde bulantı ve kusma sık görülür.</li>
        <li><strong>Teşhis Zorluğu:</strong> Belirtiler apandisit veya şiddetli gaz sancısı ile karışabilir. Ergenlik öncesi ve ergenlik dönemindeki kız çocuklarında ani karın ağrısı mutlaka bu açıdan değerlendirilmelidir.</li>
        <li><strong>Tedavi:</strong> Acil cerrahi ile yumurtalık düzeltilir ve canlılığı kontrol edilir.</li>
      </ul>

      <div className="emergency-alert-box" style={{ backgroundColor: '#fff5f5', border: '2px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <h4 style={{ color: '#c53030', marginTop: 0, display: 'flex', alignItems: 'center', gap: '10px' }}>
          <AlertTriangle size={24} /> Ebeveynler İçin Uyarı İşaretleri
        </h4>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', fontWeight: '600' }}>
          Aşağıdaki durumlarda <strong>"sabahı beklemeden"</strong> en yakın tam teşekküllü acil servise başvurulmalıdır:
        </p>
        <ul style={{ color: '#4a5568', fontSize: '0.9rem' }}>
          <li>Kasıkta veya testiste aniden başlayan, çocuğu uykudan uyandıran şiddetli ağrı.</li>
          <li>Ağrıya eşlik eden kontrol edilemeyen kusma.</li>
          <li>Testis torbasında ani renk değişimi (morarma/kızarma) ve aşırı hassasiyet.</li>
        </ul>
        <p style={{ margin: '15px 0 0', color: '#c53030', fontWeight: '800', textAlign: 'center', borderTop: '1px solid #feb2b2', paddingTop: '10px' }}>
          Unutmayın: Torsiyon şüphesinde "ağrının geçmesini beklemek" organ kaybına yol açabilir.
        </p>
      </div>
    </div>
  )
},
    { 
  id: 6, 
  title: "Hipospadias (Peygamber Sünneti)", 
  icon: <Stethoscope size={32} />, 
  color: "#4FC3F7", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Hipospadias, idrar deliğinin penisin ucunda olması gerekirken, penisin alt yüzeyinde (daha geride) 
        anyhangi bir noktada olması durumudur. Doğuştan gelen bu durum, idrar kanalı gelişiminin tam 
        tamamlanamaması nedeniyle oluşur.
      </p>

      <h4>Temel Belirtiler</h4>
      <ul>
        <li>İdrar deliğinin olması gereken yerden daha geride olması.</li>
        <li>Penisin sertleştiğinde aşağı doğru eğik durması (Kordi).</li>
        <li>Sünnet derisinin penisin ön kısmında eksik, arka kısmında ise pelerin gibi fazla olması.</li>
        <li>Çocuğun idrarını ileri doğru değil, aşağı veya ayaklarına doğru yapması.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', margin: '25px 0', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>KRİTİK SÜNNET UYARISI:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Hipospadiaslı çocuklar <strong>kesinlikle normal sünnet edilmemelidir.</strong> Fazla olan sünnet derisi, 
          ameliyat sırasında idrar kanalını yeniden yapmak için yama olarak kullanılacaktır.
        </p>
      </div>

      <h4>Tedavi ve Zamanlama</h4>
      <ul>
        <li><strong>Tek Çözüm Cerrahidir:</strong> İlaçla veya kendiliğinden düzelme ihtimali yoktur.</li>
        <li><strong>İdeal Yaş Aralığı:</strong> Psikososyal gelişim ve yara iyileşmesi açısından en uygun dönem <strong>6 ay ile 18 ay</strong> arasıdır. Okul çağına kadar bekletilmemesi önerilir.</li>
      </ul>

      <h4>Ameliyat ve İyileşme</h4>
      <p>Ameliyatın amacı; idrar deliğini penis ucuna taşımak, penisteki eğriliği düzeltmek ve estetik olarak normal bir penis görünümü sağlamaktır.</p>
      <ul>
        <li>Genellikle günübirlik veya bir gece hastanede yatış gerektiren bir işlemdir.</li>
        <li>İyileşme sürecinde yeni yapılan kanalı korumak için kısa süreliğine (birkaç gün) bir sonda kullanılabilir.</li>
      </ul>

      <div className="info-highlight-box" style={{ background: '#f0f9ff', padding: '20px', borderRadius: '15px', border: '1px solid #bae6fd', marginTop: '20px' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>
          <Star size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Önemli Not:
        </p>
        <p style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Hipospadias onarımı hassas bir cerrahidir ve <strong>ilk ameliyat en yüksek başarı şansına sahiptir.</strong> 
          Bu nedenle tecrübeli bir çocuk cerrahı veya çocuk üroloğu tarafından yapılması hayati önem taşır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 7, 
  title: "İdrar Yolu Enfeksiyonları", 
  icon: <Thermometer size={32} />, 
  color: "#FF7043", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda sık tekrarlayan enfeksiyonlar, böbrek sağlığını korumak adına mutlaka detaylı incelenmelidir. 
        En sık rastlanan nedenler şunlardır:
      </p>

      <h4>1. Veziko-üreteral Reflü (VUR - Böbrek Reflüsü)</h4>
      <p>
        <strong>Nedir?</strong> İdrarın mesaneden (idrar torbası) tekrar böbreklere doğru geri kaçmasıdır. 
        <strong> Risk:</strong> Enfeksiyonlu idrarın böbreğe ulaşması, böbrekte kalıcı hasara (skar) yol açabilir. 
        <strong> Tedavi:</strong> Derecesine göre koruyucu antibiyotik takibi, kapalı (enjeksiyon) yöntemi veya cerrahi düzeltme uygulanır.
      </p>

      <h4>2. Üretero-Pelvik (UPJ) Darlık</h4>
      <p>
        <strong>Nedir?</strong> Böbrek ile böbrekten çıkan idrar kanalının (üreter) birleştiği yerdeki darlıktır. 
        <strong> Belirti:</strong> Böbrekte şişme (hidronefroz) ve ağrı ile kendini gösterir. 
        <strong> Tedavi:</strong> İdrar akışını engelleyen darlık ciddi boyuttaysa, "Piyeloplasti" ameliyatı ile kanal genişletilir.
      </p>

      <h4>3. Üretero-Vezikal Darlık</h4>
      <p>
        <strong>Nedir?</strong> İdrar kanalının mesaneye girdiği yerdeki darlıktır. 
        <strong> Belirti:</strong> İdrar kanalı (üreter) ve böbrek genişler (Megaüreter). 
        <strong> Tedavi:</strong> İdrarın mesaneye rahat akması için kanalın mesaneye yeniden dikilmesi (reimplantasyon) gerekebilir.
      </p>

      <h4>4. Mesane ve Üreter Disfonksiyonları</h4>
      <p>
        <strong>Nedir?</strong> İdrar yollarında yapısal bir darlık olmamasına rağmen, mesanenin depolama veya boşaltma işlevini tam yapamamasıdır. 
        <strong> Nedenleri:</strong> Genellikle "mesane-bağırsak disfonksiyonu" (kabızlık ile birlikte) veya sinirsel nedenlerden kaynaklanır. 
        <strong> Tedavi:</strong> İlaç tedavisi, işeme eğitimi (üroterapi) ve kabızlığın giderilmesi ile idrar yolu enfeksiyonları kontrol altına alınır.
      </p>

      <div className="info-highlight-box" style={{ background: '#fef3c7', padding: '20px', borderRadius: '15px', borderLeft: '5px solid #f59e0b', marginTop: '25px' }}>
        <p style={{ margin: 0, color: '#92400e', fontWeight: '700', marginBottom: '10px' }}>
          <Star size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Ebeveynlere Öneri:
        </p>
        <p style={{ margin: 0, color: '#78350f', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Çocuğunuzda ateşli idrar yolu enfeksiyonu varsa, sadece antibiyotik kullanmak yeterli değildir; 
          altta yatan bu tip bir anatomik sorun olup olmadığını anlamak için <strong>Sondalı Film (VCUG)</strong> 
          veya <strong>Böbrek Sintigrafisi (DMSA)</strong> gibi ileri tetkikler gerekebilir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 8, 
  title: "External Üretral Meada Darlık", 
  icon: <Scissors size={32} />, 
  color: "#9575CD", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Meatal stenoz, idrarın vücut dışına çıktığı en uç noktadaki deliğin normalden daha dar olması durumudur. 
        Doğuştan olabileceği gibi bazen de pişik ve sünnetten sonraki dönemde, bölgenin bezle teması veya 
        tahrişi sonucu iyileşme dokusunun deliği daraltmasıyla oluşur.
      </p>

      <h4>Belirtiler Nelerdir?</h4>
      <ul>
        <li><strong>İdrar Akımında Değişiklik:</strong> İdrarın çok ince, tazyikli ve yukarıya doğru (fıskiye gibi) fırlayarak çıkması.</li>
        <li><strong>Zorlanma:</strong> Çocuğun idrar yaparken ıkınması veya normalden uzun sürede bitirmesi.</li>
        <li><strong>Damlatma:</strong> İdrar sonunda damlamanın devam etmesi.</li>
        <li><strong>Sızıntı/Yanma:</strong> İdrar deliği çevresinde kızarıklık veya idrar yaparken hafif sızlama.</li>
      </ul>

      <h4>Tedavi Süreci (Meatotomi)</h4>
      <p>
        Bu darlık kendi kendine düzelmez; ancak <strong>Meatotomi</strong> adı verilen oldukça kısa ve basit bir 
        lokal anestezik işlemle tamamen tedavi edilebilir.
      </p>
      <ul>
        <li><strong>İşlem:</strong> Dar olan bölgeye milimetrik bir müdahale yapılarak idrar deliği normal genişliğine getirilir.</li>
        <li><strong>Süre:</strong> Genellikle günübirlik bir işlemdir, hastanede yatış gerektirmez.</li>
        <li><strong>İyileşme:</strong> İşlem sonrası çocuk hemen normal idrarını yapabilir. İlk birkaç gün hafif bir sızlama olması normaldir.</li>
      </ul>

      <div className="info-box" style={{ background: '#f5f3ff', padding: '15px', borderRadius: '12px', border: '1px solid #ddd6fe', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#5b21b6', fontWeight: '700' }}>
          <ShieldCheck size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Dikkat Edilmesi Gerekenler
        </p>
        <p style={{ margin: '8px 0 0', color: '#4c1d95', fontSize: '0.95rem', lineHeight: '1.6' }}>
          İşlemden sonra doktorunuzun önerdiği kremleri düzenli kullanmak, deliğin tekrar daralmasını önlemek için kritiktir. 
          Deliğin her gün nazikçe kontrol edilmesi ve yapışıklık oluşmadığından emin olunması önerilir.
        </p>
      </div>
    </div>
  )
},
    { 
  id: 9, 
  title: "İnvajinasyon (Bağırsak Düğüm)", 
  icon: <Activity size={32} />, 
  color: "#4DB6AC", 
  longDesc: (
    <div className="treatment-details">
      <p>
        İnvajinasyon (bağırsak düğümlenmesi), bir bağırsak segmentinin teleskop gibi bir sonraki bağırsak segmentinin 
        içine girmesi durumudur. Bu durum bağırsaklarda geçici bir tıkanıklığa ve kanlanma bozukluğuna yol açar. 
        Genellikle 6 ay ile 2 yaş arası sağlıklı bebeklerde aniden ortaya çıkar.
      </p>

      <h4>En Tipik Belirtiler (Sıralı Takip)</h4>
      <ul>
        <li><strong>Kriz Şeklinde Ağrı:</strong> Bebeğiniz aniden şiddetli bir şekilde ağlamaya başlar, bacaklarını karnına doğru çeker. Bu ağrı 15-20 dakika sürer, sonra aniden durur.</li>
        <li><strong>Sakin Dönem:</strong> Ağrı geçtiğinde bebek tamamen normal, hatta bazen halsiz/uykulu görünebilir. Bu ebeveynleri yanıltmamalıdır; krizler bir süre sonra tekrar eder.</li>
        <li><strong>Kusma:</strong> Başlangıçta besinleri kusma şeklinde başlar, ilerlerse safralı (yeşil) kusmaya dönebilir.</li>
        <li><strong>Çilek Jölesi Dışkı:</strong> Hastalığın ilerleyen aşamalarında görülen, kanlı ve mukuslu (jöle kıvamında) dışkılamadır.</li>
      </ul>

      <h4>Teşhis ve Tedavi</h4>
      <p>
        Teşhis, uzman bir radyolog tarafından yapılan <strong>ultrason</strong> ile kesinleştirilir. 
        Ultrason görüntüsünde bağırsağın iç içe geçtiği "hedef tahtası" (target sign) görünümü saptanır.
      </p>
      <ul>
        <li><strong>Ameliyatsız Müdahale (Redüksiyon):</strong> Vakaların çoğunda bağırsaklar; makattan verilen hava veya özel bir sıvı (serum) yardımıyla, basınç uygulanarak geri itilir. Bu işlem sırasında cerrah ve radyolog birlikte çalışır.</li>
        <li><strong>Cerrahi Müdahale:</strong> Eğer bağırsaklar basınçla açılmıyorsa veya bağırsakta hasar şüphesi varsa, küçük bir operasyonla bağırsaklar el ile düzeltilir.</li>
      </ul>

      <div className="info-box" style={{ background: '#f0f9ff', padding: '15px', borderRadius: '12px', border: '1px solid #bae6fd', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>
          <ShieldCheck size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Eve Dönüşte Dikkat Edilmesi Gerekenler
        </p>
        <p style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem', lineHeight: '1.6' }}>
          İlk 24 saat içinde durumun tekrarlama riski (yaklaşık %10) vardır. Eğer çocuğunuzda benzer karın ağrısı atakları tekrar başlarsa vakit kaybetmeden hastaneye başvurmalısınız.
        </p>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          <strong>Unutmayın:</strong> Erken dönemde getirilen çocuklarda işlem genellikle cerrahiye gerek kalmadan, dakikalar içinde başarıyla sonuçlanır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 10, 
  title: "Labial Füzyon (Yapışıklık)", 
  icon: <UserRound size={32} />, 
  color: "#BA68C8", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Labial füzyon, vajina girişindeki iç dudakların ince, zar benzeri bir dokuyla birbirine yapışmasıdır. 
        Bu bir "doğuştan gelen eksiklik" veya "organ kapanması" değildir; sonradan gelişen, tamamen yüzeysel bir yapışıklıktır.
      </p>

      <h4>Neden Olur?</h4>
      <p>
        Kız bebeklerde östrojen hormonu seviyesi düşüktür. Bu düşük hormon seviyesine; idrar tahrişi, pişikler veya 
        o bölgenin nemli/sabunlu kalması eklenince, vücut koruma amaçlı bu ince yapışıklığı oluşturur. 
        Genellikle 3 ay ile 6 yaş arasındaki çocuklarda görülür.
      </p>

      <h4>Belirtiler Nelerdir?</h4>
      <ul>
        <li>Çoğu zaman hiçbir belirti vermez, banyo veya alt değiştirme sırasında ebeveynler tarafından fark edilir.</li>
        <li>İdrarın öne veya yukarı doğru, alışılmadık bir açıyla çıkması.</li>
        <li>Yapışıklık çok fazlaysa, idrarın içeride birikmesine bağlı olarak gelişen idrar yolu enfeksiyonları.</li>
      </ul>

      <h4>Tedavi Seçenekleri</h4>
      <p>Hastalık genellikle ergenlik döneminde, vücut östrojen üretmeye başladığında kendiliğinden çözülür. Ancak tedavi gerekiyorsa şu adımlar izlenir:</p>
      <ul>
        <li><strong>Gözlem:</strong> Eğer çocukta idrar yolu enfeksiyonu yoksa ve idrar akışı normalse, sadece takip yeterli olabilir.</li>
        <li><strong>Östrojenli Kremler:</strong> Doktorunuzun reçete edeceği kremler, bölgedeki dokuyu yumuşatarak yapışıklığın birkaç hafta içinde kendiliğinden açılmasını sağlar.</li>
        <li><strong>Manuel Açma (Nadiren):</strong> Kremlerle açılmayan veya çok sık enfeksiyona yol açan vakalarda, uzman bir doktor tarafından küçük bir müdahale ile açılabilir.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '15px', margin: '20px 0', borderRadius: '12px' }}>
        <p style={{ color: '#c53030', fontWeight: '800', margin: '0 0 10px 0' }}>ASLA YAPILMAMALIDIR:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', margin: 0 }}>
          Ebeveynlerin evde bu dokuyu ayırmaya çalışması doku hasarına ve tekrar yapışmaya neden olabileceği için 
          <strong> asla önerilmez.</strong>
        </p>
      </div>

      <h4>Tekrarlamasını Önlemek İçin</h4>
      <ul>
        <li>Bebeğinizin altını sık sık değiştirin, bölgenin kuru ve temiz kalmasına özen gösterin.</li>
        <li>Banyo sırasında o bölgeye doğrudan sert sabun veya şampuan sürmekten kaçının.</li>
        <li>İyileşme sonrası doktorunuzun önereceği bariyer kremleri (vazelin vb.) bir süre kullanarak temas yüzeyini koruyun.</li>
      </ul>
    </div>
  )
},
   { 
  id: 11, 
  title: "Anal Darlık", 
  icon: <Zap size={32} />, 
  color: "#FF8A65", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Anal darlık, dışkının vücut dışına çıktığı kanalın veya makat ağzının normalden daha dar olması durumudur. 
        Bu durum doğuştan (yapısal) olabileceği gibi, bazen o bölgedeki küçük çatlakların iyileşirken 
        oluşturduğu sert doku nedeniyle de gelişebilir.
      </p>

      <h4>Belirtiler Nelerdir?</h4>
      <ul>
        <li><strong>Şiddetli Ikınma:</strong> Bebeğin dışkı yaparken aşırı zorlanması, basınçlı kaka yapması, yüzünün kızarması ve ağlaması.</li>
        <li><strong>İnce Dışkılama:</strong> Dışkının kalem gibi ince veya şerit şeklinde çıkması.</li>
        <li><strong>Kabızlık ve Gaz Sancısı:</strong> Karnın şiş olması ve dışkılamanın tam boşalamaması nedeniyle sürekli huzursuzluk.</li>
        <li><strong>Makat Çatlakları:</strong> Zorlanmaya bağlı olarak makat kenarında küçük kanamalı çatlaklar (fissür) oluşması.</li>
      </ul>

      <h4>Tedavi ve Süreç</h4>
      <p>Anal darlık, çocuğun büyümesini ve yaşam kalitesini etkilememesi için müdahale edilmesi gereken bir durumdur.</p>
      <ul>
        <li><strong>Anal Dilatasyon (Genişletme):</strong> En yaygın tedavi yöntemidir. Doktorunuzun belirlediği periyotlarda, özel tıbbi aletler (bujiler) veya parmak yardımıyla o bölgenin nazikçe genişletilmesi işlemidir.</li>
        <li><strong>Cerrahi Müdahale (Anoplasti):</strong> Eğer darlık dilatasyon ile açılmayacak kadar sert veya darsa, makat ağzını genişletmek için küçük bir cerrahi operasyon gerekebilir.</li>
      </ul>

      <div className="info-highlight-box" style={{ background: '#fefce8', padding: '15px', borderRadius: '12px', border: '1px solid #fef08a', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#854d0e', fontWeight: '700' }}>
          <ShieldCheck size={18} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Dikkat Edilmesi Gerekenler
        </p>
        <ul style={{ margin: '8px 0 0', color: '#713f12', fontSize: '0.95rem' }}>
          <li>Dışkı Yumuşatıcılar: Dışkının sertleşmemesi için doktorunuzun önerdiği diyet veya şuruplar kullanılmalıdır.</li>
          <li>Düzenli Takip: Dilatasyon egzersizleri doktorun önerdiği süreden önce bırakılmamalıdır.</li>
          <li>Hijyen: Yeni çatlak oluşumunu önlemek için bölge temiz tutulmalıdır.</li>
        </ul>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#f0f9ff', borderLeft: '5px solid #0ea5e9', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#0369a1', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#1e293b', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Anal darlık, <strong>bağırsak tembelliği değildir.</strong> Mekanik bir darlıktır ve düzenli genişletme 
          tedavisiyle çocukların çok büyük bir kısmı tamamen sağlığına kavuşur, normal tuvalet alışkanlığı kazanır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 12, 
  title: "Dilaltı Bağı Cerrahisi", 
  icon: <Scissors size={32} />, 
  color: "#AED581", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Dil bağı, dili ağız tabanına bağlayan dokunun (frenulum) normalden kısa, kalın veya dilin çok ucuna yakın 
        olması durumudur. Bu durum dilin hareket kabiliyetini kısıtlayarak <strong>"kalp şeklinde"</strong> bir dil 
        görüntüsüne neden olabilir.
      </p>

      <h4>Belirtiler Nelerdir?</h4>
      <p>Her dil bağı tedavi gerektirmez. Ancak şu belirtiler varsa müdahale planlanabilir:</p>
      <ul>
        <li><strong>Beslenme Sorunları:</strong> Bebeğin memeyi tam kavrayamaması, emerken çabuk yorulması veya meme başında ağrı/çatlak oluşması.</li>
        <li><strong>Dil Hareket Kısıtlılığı:</strong> Çocuğun dilini üst damağa değdirememesi veya dışarıya (alt dişlerin ötesine) çıkaramaması.</li>
        <li><strong>Şekil Bozukluğu:</strong> Dil dışarı çıkarılmaya çalışıldığında ucunda oluşan çentik (kalp şekli).</li>
        <li><strong>Konuşma Bozuklukları:</strong> İlerleyen yaşlarda özellikle "l, r, s, t, z" gibi harflerin telaffuzunda zorlanma.</li>
      </ul>

      <h4>Tedavi: Dil Bağı Kesilmesi (Frenotomi)</h4>
      <p>Dil bağı müdahalesi, çocuk cerrahisinde en kısa süren ve iyileşme hızı en yüksek işlemlerden biridir.</p>
      <ul>
        <li><strong>İşlem:</strong> Dilin altındaki bu ince doku, cerrahi makas yardımıyla serbestleştirilir.</li>
        <li><strong>Süre:</strong> Saniyeler süren bir işlemdir. Genellikle lokal anestezi (uyuşturucu sprey veya jel) yeterli olur.</li>
        <li><strong>İyileşme:</strong> İşlemden hemen sonra bebek emzirilebilir veya beslenebilir. Anne sütü, bölgenin iyileşmesi için en doğal "pansuman" görevi görür.</li>
      </ul>

      <div className="info-highlight-box" style={{ background: '#f0fdf4', padding: '15px', borderRadius: '12px', border: '1px solid #bbf7d0', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#166534', fontWeight: '700' }}>Bilinmesi Gereken Yanlışlar</p>
        <ul style={{ margin: '8px 0 0', color: '#14532d', fontSize: '0.95rem' }}>
          <li><strong>"Konuşamaz" Korkusu:</strong> Dil bağı çocuğun hiç konuşamamasına neden olmaz; sadece bazı harflerin netliğini etkileyebilir.</li>
          <li><strong>"Geç Kalındı" Endişesi:</strong> Bebeklik döneminde kaçırılmış olsa bile, çocukluk döneminde de güvenle uygulanabilir.</li>
        </ul>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fffbe6', borderLeft: '5px solid #fadb14', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#856404', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Her "kısa" görünen dil bağına müdahale edilmez. Eğer bebeğiniz kilo alıyorsa, rahat emiyorsa ve 
          ileride telaffuz sorunu yaratmayacak bir yapıdaysa sadece takip edilmesi yeterli olabilir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 13, 
  title: "Karın Ağrısı ve Kusma", 
  icon: <AlertCircle size={32} />, 
  color: "#E57373", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda karın ağrısı ve kusma çok sık görülen şikayetlerdir. Çoğu zaman basit bir mide üşütmesi 
        veya gaz sancısı olsa da, bazen acil cerrahi müdahale gerektiren (apandisit, bağırsak düğümlenmesi vb.) 
        durumların habercisi olabilir.
      </p>

      <h4>Ne Zaman Endişelenmelisiniz? (Tehlike İşaretleri)</h4>
      <p>Aşağıdaki belirtilerden biri veya birkaçı varsa vakit kaybetmeden bir Çocuk Cerrahisi uzmanına başvurmalısınız:</p>
      <ul>
        <li><strong>Sürekli ve Artan Ağrı:</strong> Ağrı şiddetleniyor, uykudan uyandırıyor veya çocuğun dik yürümesine engel oluyorsa.</li>
        <li><strong>Safralı (Yeşil/Sarı) Kusma:</strong> Kusmanın rengi yeşilimsi veya parlak sarıysa bu bağırsak tıkanıklığı belirtisi olabilir.</li>
        <li><strong>Karında Sertlik ve Hassasiyet:</strong> Çocuğun karnına dokundurtmaması, karnın tahta gibi sert olması.</li>
        <li><strong>Kanlı Dışkılama:</strong> Dışkıda taze kan veya jöle benzeri bir yapı görülmesi.</li>
        <li><strong>Genel Durum Bozukluğu:</strong> Aşırı halsizlik, solgunluk, gözlerde çökme veya sürekli uyku hali.</li>
      </ul>

      <h4>Ebeveynlerin Sık Sorduğu Sorular</h4>
      <p>
        <strong>1. "Hemen ağrı kesici verebilir miyim?"</strong> Hayır. Tanı konulmadan verilen ağrı kesiciler, 
        altta yatan ciddi bir cerrahi sorunun belirtilerini maskeleyerek teşhisi geciktirebilir.
      </p>
      <p>
        <strong>2. "Kusuyorsa ne yedirmeliyim?"</strong> Kusma devam ediyorsa mideyi yormamak için beslenmeye ara verilmelidir. 
        Durduktan sonra azar azar su veya haşlanmış patates gibi yağsız gıdalar denenebilir.
      </p>
      <p>
        <strong>3. "Apandisit mi?"</strong> Ağrı genellikle göbek çevresinde başlayıp sağ alt karın bölgesine yerleşir. 
        Çocuk zıplarken veya öksürürken ağrının arttığını söylüyorsa mutlaka cerrah görmelidir.
      </p>

      <div className="info-box" style={{ background: '#fefce8', padding: '15px', borderRadius: '12px', border: '1px solid #fef08a', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#854d0e', fontWeight: '700' }}>Evde Takip Önerileri</p>
        <ul style={{ margin: '8px 0 0', color: '#713f12', fontSize: '0.95rem' }}>
          <li>Ağrının tam yerini ve karakterini (sürekli mi, dalgalı mı?) gözlemleyin.</li>
          <li>İdrar ve dışkı miktarını/rengini not edin.</li>
          <li><strong>Sıcak uygulamadan kaçının;</strong> bu, apandisit gibi iltihabi durumları kötüleştirebilir.</li>
        </ul>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ HATIRLATMA:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          "Çocuktur, bir şey dokunmuştur" diyerek geçiştirilmeyen her erken teşhis, cerrahi süreçlerin çok daha kolay 
          ve komplikasyonsuz atlatılmasını sağlar.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 14, 
  title: "Gastro-Ozefagial Reflü", 
  icon: <FlaskConical size={32} />, 
  color: "#AED581", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Gastroözofageal Reflü (GÖR) mide içeriğinin (besin ve asit) istemsizce yemek borusuna geri kaçmasıdır. 
        Bebeklerde mide ile yemek borusu arasındaki kapakçık henüz tam gelişmediği için, özellikle ilk bir yıl 
        içinde bu durum oldukça yaygındır.
      </p>

      <h4>"Mutlu Tükürücü" mü, Reflü Hastası mı?</h4>
      <p>
        Çoğu bebekte görülen reflü, bebeğin gelişimini etkilemeyen, sadece kıyafet kirleten <strong>"fizyolojik reflü"</strong> 
        durumudur. Ancak şu belirtiler varsa "Reflü Hastalığı"ndan (GÖRH) şüphelenilir:
      </p>
      <ul>
        <li><strong>Fışkırır Tarzda Kusma:</strong> Sadece ağız kenarından sızma değil, tazyikli kusmalar.</li>
        <li><strong>Kilo Alımında Duraklama:</strong> Bebeğin aylık kontrollerinde beklenen kiloyu alamaması.</li>
        <li><strong>Beslenme Reddi:</strong> Bebeğin memeyi veya biberonu görünce ağlayarak kendini geriye doğru atması.</li>
        <li><strong>Huzursuzluk:</strong> Özellikle beslenme sonrası veya yatırıldığında artan ağlama krizleri.</li>
        <li><strong>Sık Tekrarlayan Akciğer Sorunları:</strong> Geçmeyen öksürük, hırıltı veya tekrarlayan akciğer enfeksiyonları.</li>
      </ul>

      <div className="info-box" style={{ background: '#f0fdf4', padding: '15px', borderRadius: '12px', border: '1px solid #bbf7d0', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#166534', fontWeight: '700' }}>Evde Uygulanabilecek Önlemler</p>
        <ul style={{ margin: '8px 0 0', color: '#14532d', fontSize: '0.95rem' }}>
          <li><strong>Beslenme Sonrası Pozisyon:</strong> Beslemeden sonra bebek en az 20-30 dakika dik tutulmalıdır.</li>
          <li><strong>Az ve Öz Besleme:</strong> Daha sık aralıklarla ama daha küçük porsiyonlarla besleme yapılmalıdır.</li>
          <li><strong>Yatak Açısı:</strong> Yatağın baş tarafı 30-45 derece kadar yükseltilmelidir.</li>
          <li><strong>Gaz Çıkarma:</strong> Beslenme sırasında ve sonrasında gaz çıkarma ihmal edilmemelidir.</li>
        </ul>
      </div>

      <h4>Tedavi Ne Zaman Gerekir?</h4>
      <ul>
        <li><strong>İlaç Tedavisi:</strong> Yaşam tarzı değişikliğine yanıt vermeyen vakalarda mide asidini düzenleyen şuruplar.</li>
        <li><strong>Cerrahi:</strong> İlaç tedavisine yanıt vermeyen veya ciddi solunum problemi yaratan nadir vakalarda kapakçık güçlendirilir.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fffbe6', borderLeft: '5px solid #fadb14', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#856404', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Bebeklerin %50’sinden fazlasında ilk 3 ayda reflü görülür ve bunların büyük çoğunluğu ek gıdaya geçişle 
          veya destek almadan oturmaya başladıkları dönemde kendiliğinden düzelir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 15, 
  title: "Karaciğer ve Safra Kesesi", 
  icon: <Heart size={32} />, 
  color: "#E57373", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda karaciğer ve safra yolları ile ilgili sorunlar, bazen doğuştan gelen yapısal bozukluklar, 
        bazen de sonradan gelişen taş veya kistler nedeniyle oluşur. Bu hastalıkların en önemli belirtisi <strong>"sarılık"</strong>tır.
      </p>

      <h4>Dikkat Edilmesi Gereken Belirtiler</h4>
      <ul>
        <li><strong>Uzamış Sarılık:</strong> Yenidoğan bebekte sarılığın 2 haftadan uzun sürmesi.</li>
        <li><strong>Dışkı Renginde Değişim:</strong> Dışkının beyaz, kil rengi veya çok açık renkli olması (akolik dışkı).</li>
        <li><strong>Koyu Renkli İdrar:</strong> İdrarın çay rengi gibi koyu çıkması.</li>
        <li><strong>Karın Şişliği:</strong> Sağ üst karın bölgesinde ele gelen kitle veya belirgin şişlik.</li>
        <li><strong>Şiddetli Karın Ağrısı:</strong> Özellikle yemeklerden sonra sağ üst karın bölgesinde oluşan ağrılar.</li>
      </ul>

      <h4>Sık Karşılaşılan Cerrahi Durumlar</h4>
      <p><strong>1. Biliyer Atrezi (Safra Yollarının Yokluğu):</strong> Safra yollarının doğuştan kapalı olmasıdır. İlk <strong>60 gün</strong> içinde teşhis edilip müdahale edilmesi (Kasai operasyonu), karaciğerin korunması açısından hayatidir.</p>
      <p><strong>2. Koledok Kistleri:</strong> Safra kanallarının balonlaşarak genişlemesidir. Genellikle cerrahi olarak kistin çıkarılması ve safra akışının yeniden düzenlenmesi gerekir.</p>
      <p><strong>3. Safra Kesesi Taşları:</strong> Şiddetli ağrı veya iltihaba neden oluyorsa kapalı yöntemle (Laparoskopik Kolesistektomi) safra kesesi alınır.</p>

      <div className="info-box" style={{ background: '#f0f9ff', padding: '15px', borderRadius: '12px', border: '1px solid #bae6fd', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>Teşhis ve Tedavi</p>
        <p style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem' }}>
          Teşhis aşamasında kan tahlilleri ile <strong>ayrıntılı bir ultrason</strong> ilk adımdır. Gerekli durumlarda MR (MRCP) veya sintigrafi gibi ileri görüntüleme yöntemleri kullanılır.
        </p>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <AlertTriangle size={24} color="#e53e3e" style={{ marginBottom: '10px' }} />
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Bebeğinizin sarılığı "anne sütü sarılığıdır, geçer" denilerek takip ediliyorsa ancak <strong>dışkı rengi açılıyorsa</strong>, 
          bu durum mutlaka bir Çocuk Cerrahisi uzmanı tarafından cerrahi bir tıkanıklık açısından değerlendirilmelidir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 16, 
  title: "Kabızlık ve Kaka Kaçırma", 
  icon: <Waves size={32} />, 
  color: "#4DD0E1", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda kabızlık sadece dışkı yapamama hali değil; dışkının sertleşmesi, yaparken ağrı duyulması ve 
        dışkılama sıklığının azalmasıdır. <strong>Kaka kaçırma (enkoprezis)</strong> ise genellikle uzun süreli 
        kabızlığın bir sonucudur ve çocuğun bilerek yaptığı bir "yaramazlık" değildir.
      </p>

      <h4>Kabızlık Neden Olur?</h4>
      <p>Çoğu zaman altta yatan ciddi bir hastalık yoktur (fonksiyonel kabızlık). Genellikle;</p>
      <ul>
        <li>Tuvalet eğitimi sırasında yaşanan zorluklar,</li>
        <li>Okul veya yabancı yerlerde tuvalete gitmeyi erteleme (tutma alışkanlığı),</li>
        <li>Lifli gıdalardan fakir beslenme ve az su tüketimi nedeniyle başlar.</li>
      </ul>

      <h4>Kaka Kaçırma (Enkoprezis) Nedir?</h4>
      <p>
        Uzun süre dışkısını tutan çocuğun kalın bağırsağının son kısmı genişler ve duyarsızlaşır. İçeride biriken 
        sert ve büyük dışkı kütlesinin kenarlarından sızan yumuşak dışkı, çocuk farkında olmadan iç çamaşırına kaçar. 
        Bu aslında <strong>şiddetli kabızlığın</strong> bir işaretidir.
      </p>

      <h4>Tedavi Yolları</h4>
      <p>Tedavi sabır gerektiren uzun bir yolculuktur ve şu basamaklardan oluşur:</p>
      <ul>
        <li><strong>Boşaltma Evresi:</strong> Bağırsaktaki sertleşmiş kütle, tıbbi yöntemlerle temizlenir.</li>
        <li><strong>İlaç Tedavisi (Dışkı Yumuşatıcılar):</strong> Dışkının "ketçap kıvamında" kalmasını sağlayan şuruplar kullanılır. Bu ilaçlar bağırsakları tembelleştirmez.</li>
        <li><strong>Tuvalet Eğitimi ve Alışkanlık:</strong> Yemeklerden 15-20 dakika sonra çocuğun tuvalete oturması (gastrokolik refleks) sağlanmalıdır.</li>
        <li><strong>Beslenme Düzeni:</strong> Bol su, sebze, meyve (kayısı, erik, armut) ve tam tahıllı gıdalar tüketilmelidir.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', margin: '20px 0', borderRadius: '15px' }}>
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>ASLA CEZALANDIRMAYIN:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Kaka kaçırma istemsizdir. Çocuğa kızmak veya onu utandırmak sorunu derinleştirir ve iyileşme sürecini uzatır. 
          Çocuk düzenli yapmaya başlasa bile bağırsağın eski formuna dönmesi aylar sürebilir.
        </p>
      </div>

      <div className="info-highlight-box" style={{ background: '#f0f9ff', padding: '15px', borderRadius: '12px', border: '1px solid #bae6fd', marginTop: '20px' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>Önemli Not:</p>
        <p style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Eğer bebeğiniz doğduğu <strong>ilk 24-48 saat</strong> içinde kakasını yapmadıysa veya kabızlıkla beraber kilo alımında gerilik varsa, 
          bu durum <strong>"Hirschsprung Hastalığı"</strong> gibi cerrahi müdahale gerektiren bir durumun işareti olabilir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 17, 
  title: "İdrar Kaçırma", 
  icon: <Anchor size={32} />, 
  color: "#7986CB", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda idrar kontrolü genellikle 4-5 yaşına kadar tamamlanır. Bu yaştan sonra devam eden idrar kaçırmalar 
        veya gün içinde aşırı sık tuvalete gitme ihtiyacı, bazen basit bir alışkanlık sorunu bazen de mesane 
        fonksiyonlarındaki bir düzensizliğin işareti olabilir.
      </p>

      <h4>Farklı Tipler, Farklı Nedenler</h4>
      <p>
        <strong>1. Gece İdrar Kaçırma (Enürezis Nokturna):</strong> Çocuğun sadece uykuda idrar kaçırmasıdır. 
        Genellikle genetik yatkınlık veya gece idrar miktarını azaltan hormonun yetersizliği nedeniyle oluşur. 
        Çoğu zaman bir hastalık değil, gelişimsel bir gecikmedir.
      </p>
      <p>
        <strong>2. Gündüz İdrar Kaçırma ve Sık Çıkma:</strong> Gün içinde ani sıkışma hissi veya tuvalete yetişememe durumudur. 
        "Aşırı aktif mesane" veya idrar tutma manevraları (bacak çaprazlama vb.) ile birlikte görülebilir.
      </p>

      <h4>Ne Zaman Tetkik Yapılmalı?</h4>
      <ul>
        <li>Çocuk idrar yaparken yanma veya sancı hissediyorsa.</li>
        <li>Kesik kesik veya çok ince tazyikle idrar yapıyorsa.</li>
        <li>En az 6 ay kuru kalmışken sonradan kaçırmaya başladıysa.</li>
        <li>İdrar kaçırmaya kabızlık eşlik ediyorsa.</li>
      </ul>

      <div className="info-box" style={{ background: '#f0f9ff', padding: '15px', borderRadius: '12px', border: '1px solid #bae6fd', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>Evde Uygulanabilecek Öneriler</p>
        <ul style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem' }}>
          <li><strong>İşeme Günlüğü:</strong> Sıvı tüketimi ve tuvalet saatlerini not etmek tanıyı kolaylaştırır.</li>
          <li><strong>Sıvı Kısıtlaması:</strong> Akşam yemeğinden sonra sıvı alımı kademeli olarak azaltılmalıdır.</li>
          <li><strong>Düzenli Tuvalet Takvimi:</strong> Sıkışmayı beklemeden 2-3 saatte bir tuvalete gidilmelidir.</li>
          <li><strong>Kabızlığı Önleyin:</strong> Bağırsakların dolu olması mesaneye baskı yaparak kaçırmayı tetikler.</li>
        </ul>
      </div>

      <h4>Tedavi Seçenekleri</h4>
      <ul>
        <li><strong>Mesane Eğitimi:</strong> Doğru pozisyon ve zamanlı işeme alışkanlığı kazandırılması.</li>
        <li><strong>Alarm Tedavisi:</strong> Gece uyanma refleksini geliştirmek için kullanılan cihazlar.</li>
        <li><strong>İlaç Tedavisi:</strong> Mesane kapasitesini artıran veya gece idrar üretimini azaltan güvenli ilaçlar.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ HATIRLATMA:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          İdrar kaçırma çocuğun bilerek yaptığı bir durum değildir. Bu süreçte çocuğa kızmak özgüven kaybına yol açar. 
          Sabır ve doğru tıbbi destekle bu sorun <strong>%100'e yakın başarıyla</strong> çözülür.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 18, 
  title: "Meme Hastalıkları", 
  icon: <ShieldCheck size={32} />, 
  color: "#F06292", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocukluk ve ergenlik döneminde meme dokusunda fark edilen şişlikler veya hassasiyetler genellikle 
        cerrahi bir hastalıktan ziyade, vücudun büyüme ve hormon değişimlerine verdiği tepkilerdir.
      </p>

      <h4>Sık Karşılaşılan Durumlar</h4>
      <ul>
        <li><strong>Yenidoğan Dönemi Meme Şişmesi:</strong> Anneden geçen hormonlara bağlıdır ve birkaç hafta içinde geçer. <strong>Kesinlikle ovulmamalı ve sıkılmamalıdır;</strong> bu durum ciddi enfeksiyon riski yaratır.</li>
        <li><strong>Erken Meme Gelişimi (Prematür Telarş):</strong> Kız çocuklarında 8 yaştan önce meme dokusunun belirginleşmesidir. Erken ergenlik ayrımı için değerlendirilmelidir.</li>
        <li><strong>Ergenlik Dönemi Meme Büyümesi (Jinekomasti):</strong> Erkek çocuklarının yarısında görülebilen, hormonal kaynaklı geçici bir durumdur; genellikle 1-2 yıl içinde kendiliğinden düzelir.</li>
        <li><strong>Meme Kitleleri (Fibroadenomlar):</strong> Genç kızlarda görülen hareketli kitlelerdir. Çocukluk çağında kanser riski yok denecek kadar azdır ancak takip edilmelidir.</li>
      </ul>

      <h4>Ne Zaman Doktora Başvurulmalı?</h4>
      <ul>
        <li><strong>Enfeksiyon Belirtileri:</strong> Memede aşırı kızarıklık, ısı artışı, şiddetli ağrı ve yüksek ateş.</li>
        <li><strong>Akıntı:</strong> Meme başından kanlı veya iltihaplı akıntı gelmesi.</li>
        <li><strong>Hızlı Büyüme:</strong> Kitlenin çok kısa sürede belirgin şekilde büyümesi.</li>
        <li><strong>Asimetri:</strong> İki meme arasında çok belirgin ve rahatsız edici boyut farkı oluşması.</li>
      </ul>

      <div className="info-box" style={{ background: '#fdf2f8', padding: '15px', borderRadius: '12px', border: '1px solid #fbcfe8', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#9d174d', fontWeight: '700' }}>Tanı ve Tedavi Yaklaşımı</p>
        <p style={{ margin: '8px 0 0', color: '#831843', fontSize: '0.95rem', lineHeight: '1.6' }}>
          Çocuklarda meme dokusunu değerlendirirken ilk başvurulan yöntem radyasyon içermeyen <strong>Meme Ultrasonu</strong>'dur. 
          Çoğu vaka cerrahiye gerek kalmadan sadece düzenli takiple izlenir.
        </p>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fff5f5', borderLeft: '5px solid #e53e3e', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#c53030', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Ergenlik döneminde meme dokusundaki değişimler çocuklar için utanç verici olabilir. Onları bunun doğal bir 
          süreç olduğu konusunda sakinleştirmek ve uzman görüşü almak sosyal kaygılarını azaltacaktır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 19, 
  title: "Boyun Bölgesi Hastalıkları", 
  icon: <Search size={32} />, 
  color: "#4DB6AC", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuklarda boyun bölgesindeki şişliklerin çoğu enfeksiyonlara bağlı gelişen geçici durumlar olsa da, 
        bazıları anne karnındaki gelişimden kalan kistler veya tiroit ile ilgili sorunlar olabilir.
      </p>

      <h4>1. Boyunda Bezeler (Lenfadenopati - LAP)</h4>
      <p>
        Genellikle üst solunum yolu enfeksiyonları veya bademcik iltihabı sonrası lenf bezlerinin büyümesidir. 
        <strong> Ne zaman endişelenmeli?</strong> Beze çok sertse, cilde yapışıksa, 2 cm’den büyükse ve antibiyotik 
        tedavisine rağmen küçülmüyorsa uzman görüşü alınmalıdır.
      </p>

      <h4>2. Eğri Boyun (Tortikolis)</h4>
      <p>
        Bebeklerin başının bir yöne doğru eğik, çenesinin ise aksi yöne bakması durumudur. Erken dönemde başlanan 
        özel egzersizler ve fizik tedavi ile %90'ın üzerinde başarı sağlanır.
      </p>

      <h4>3. Gelişimsel Kistler (Tiroglossal ve Brankial)</h4>
      <ul>
        <li><strong>Tiroglossal Kist:</strong> Boynun tam orta hattında görülür. Çocuk yutkunduğunda veya dilini çıkardığında kist yukarı-aşağı hareket eder.</li>
        <li><strong>Brankial Kist/Fistül:</strong> Boynun yan taraflarında şişlik veya küçük bir delikten akıntı şeklinde görülür.</li>
      </ul>

      <h4>4. Tiroit Bezi ve Kistik Higroma</h4>
      <p>
        Tiroit nodülleri çocuklarda nadirdir ancak fark edildiğinde biyopsi veya ultrason ile değerlendirilmelidir. 
        <strong> Kistik Higroma</strong> ise doğuştan gelen lenf damarı genişlemeleridir ve günümüzde cerrahi dışı yöntemlerle de tedavi edilebilmektedir.
      </p>

      <div className="emergency-alert-box" style={{ backgroundColor: '#fff5f5', border: '1px solid #feb2b2', padding: '15px', marginTop: '20px', borderRadius: '15px' }}>
        <p style={{ margin: 0, color: '#c53030', fontWeight: '700' }}>Ne Zaman Acil Müdahale Gerekir?</p>
        <ul style={{ margin: '8px 0 0', color: '#4a5568', fontSize: '0.9rem' }}>
          <li>Şişlik üzerinde ani gelişen kızarıklık, ısı artışı ve ağrı varsa.</li>
          <li>Nefes almayı veya yutkunmayı zorlaştırıyorsa.</li>
          <li>Gece terlemesi, hızlı kilo kaybı veya geçmeyen ateş eşlik ediyorsa.</li>
        </ul>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#f0f9ff', borderLeft: '5px solid #0ea5e9', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#0369a1', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#1e293b', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Boyun kitlelerinin tanısında ilk basamak <strong>yüksek çözünürlüklü ultrasondur.</strong> Tanı netleşmeden 
          şişliklerin üzerine sıcak uygulama veya masaj yapmak enfeksiyonun yayılmasına neden olabilir.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 20, 
  title: "Göbekten Akıntı ve Kanama", 
  icon: <Flame size={32} />, 
  color: "#FFD54F", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Bebeklerde göbek kordonu düştükten sonra o bölgenin tamamen kuru ve temiz olması beklenir. 
        Eğer göbek deliğinde geçmeyen bir ıslaklık, kanama veya akıntı fark ederseniz, bu durum birkaç 
        farklı nedenden kaynaklanıyor olabilir.
      </p>

      <h4>Sık Karşılaşılan Nedenler</h4>
      <ul>
        <li><strong>Göbek Granülomu (Et Parçası):</strong> Göbek düştükten sonra kalan küçük dokudur. Sürekli sarımsı akıntıya neden olur. <strong>Tedavi:</strong> "Gümüş nitrat" kalemi ile bu doku kolayca kurutulabilir.</li>
        <li><strong>Omfalit (Göbek Enfeksiyonu):</strong> Göbek çevresinde kızarıklık, ısı artışı ve kötü kokulu akıntı ile karakterizedir. <strong>Dikkat:</strong> Acil tıbbi müdahale gerektirir.</li>
      </ul>

      <h4>Gelişimsel Kanal Açıklıkları (Cerrahi Durumlar)</h4>
      <p>Anne karnındaki gelişim sırasında kapanması gereken kanalların açık kalması durumudur:</p>
      <ul>
        <li><strong>Urachus (Urakus) Artıkları:</strong> Mesane ile göbek arasındaki kanalın kapanmamasıdır. Göbekten idrar gelmesine neden olabilir.</li>
        <li><strong>Omfalomezenterik Kanal Artıkları:</strong> Bağırsak ile göbek arasındaki kanalın açık kalmasıdır. Göbekten dışkı gelmesi veya mukuslu akıntı ile kendini gösterir.</li>
      </ul>

      <h4>Ne Zaman Doktora Başvurulmalı?</h4>
      <ul>
        <li>Göbek bağı düştükten 2 hafta sonra hala akıntı devam ediyorsa.</li>
        <li>Göbekten gelen sıvı idrar veya dışkı kokuyorsa.</li>
        <li>Göbek çevresinde genişleyen bir kızarıklık ve ödem varsa.</li>
      </ul>

      <div className="info-box" style={{ background: '#fffbeb', padding: '15px', borderRadius: '12px', border: '1px solid #fef3c7', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#92400e', fontWeight: '700' }}>Evde Bakım Önerileri</p>
        <ul style={{ margin: '8px 0 0', color: '#78350f', fontSize: '0.95rem' }}>
          <li><strong>Kuru Tutun:</strong> Bebeğinizin bezini göbek deliğinin altında kalacak şekilde katlayın.</li>
          <li><strong>Müdahale Etmeyin:</strong> Bölgeyi zorlamayın; sadece dışarı sızan akıntıyı nazikçe kurulayın.</li>
          <li><strong>Kimyasal Sürmeyin:</strong> Doktorunuz önermediği sürece alkol veya kolonya sürmekten kaçının.</li>
        </ul>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#f0f9ff', borderLeft: '5px solid #0ea5e9', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#0369a1', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#1e293b', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Göbekten gelen kronik akıntılar bazen sadece yüzeysel bir sorundur, ancak bazen içerideki organlarla 
          bağlantılı bir kanalın habercisidir. Bu ayrımın uzman bir <strong>çocuk cerrahı</strong> tarafından 
          yapılması en güvenli yoldur.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 21, 
  title: "Rektal Kanama", 
  icon: <Droplets size={32} />, 
  color: "#E57373", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Çocuğunuzun dışkısında veya bezinde kan görmeniz endişe verici olabilir. Kanamanın rengi, miktarı 
        ve çocuğun genel durumu, nedenini anlamamızda en büyük ipuçlarıdır.
      </p>

      <h4>Kanamanın En Sık Görülen Nedenleri</h4>
      <ul>
        <li><strong>Anal Fissür (Makat Çatlağı):</strong> En yaygın nedendir. Kabızlığa bağlı oluşur. Dışkı üzerinde çizgi şeklinde parlak kırmızı kan ve ağrı ile kendini gösterir.</li>
        <li><strong>Bağırsak Polipleri (Juvenil Polip):</strong> Genellikle ağrısızdır. Dışkılama sonrası damla damla veya dışkıya karışık taze kan görülür.</li>
        <li><strong>İnvajinasyon (Bağırsak Düğümlenmesi):</strong> Şiddetli karın ağrısı ile birlikte "çilek jölesi" kıvamında kanlı-mukuslu dışkılama görülür. <strong>Acil durumdur.</strong></li>
        <li><strong>Meckel Divertikülü:</strong> Ağrı olmaksızın, aniden gelişen bol miktarda, vişne çürüğü renginde kanama ile karakterizedir.</li>
        <li><strong>Besin Alerjileri ve Enfeksiyonlar:</strong> Özellikle süt alerjisi veya ishallerde kan ve mukus görülebilir.</li>
      </ul>

      <div className="info-highlight-box" style={{ background: '#fff5f5', padding: '15px', borderRadius: '12px', borderLeft: '5px solid #f87171', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#991b1b', fontWeight: '700' }}>Kanamanın Rengine Göre İpuçları</p>
        <p style={{ margin: '8px 0 0', color: '#7f1d1d', fontSize: '0.95rem' }}>
          <strong>Parlak Kırmızı:</strong> Makat ağzına yakın (çatlak/polip) sorunları işaret eder.<br/>
          <strong>Koyu Vişne / Siyah:</strong> Sindirim sisteminin üst kısımlarından gelen kanamayı işaret edebilir.
        </p>
      </div>

      <h4>Ne Zaman Acil Doktora Başvurulmalı?</h4>
      <ul>
        <li>Kanama miktarı fazlaysa ve durmuyorsa.</li>
        <li>Şiddetli karın ağrısı, kusma veya ateş eşlik ediyorsa.</li>
        <li>Çocuğun rengi solmuşsa, halsizse veya kanama "jöle" kıvamındaysa.</li>
      </ul>

      <h4>Teşhis Süreci</h4>
      <p>Tanı için öncelikle fizik muayene yapılır. Gerekli durumlarda laboratuvar tahlilleri, ultrason, Meckel sintigrafisi veya kolonoskopik incelemeler istenebilir.</p>

      <div className="warning-box" style={{ backgroundColor: '#f0f9ff', borderLeft: '5px solid #0ea5e9', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#0369a1', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ HATIRLATMA:</p>
        <p style={{ color: '#1e293b', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Bazı gıdalar (pancar, kırmızı boyalı içecekler) veya ilaçlar (demir takviyeleri) dışkıyı kırmızı/siyah renge 
          boyayabilir. Böyle bir şüpheniz varsa son 24 saatteki beslenmeyi mutlaka doktorunuza belirtiniz.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 22, 
  title: "Kıl Dönmesi", 
  icon: <Biohazard size={32} />, 
  color: "#A1887F", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Pilonidal sinüs, halk arasında <strong>"kıl dönmesi"</strong> olarak bilinen, genellikle kuyruk sokumu bölgesindeki 
        cilt altında bir boşluk (sinüs) ve bu boşluğun içinde kıl yumağı birikmesi durumudur. Vücut bu kılları 
        "yabancı madde" olarak algıladığı için bölgede sürekli bir iltihaplanma süreci başlar.
      </p>

      <h4>Belirtiler Nelerdir?</h4>
      <ul>
        <li><strong>Küçük Delikler:</strong> Kuyruk sokumunda bir veya birden fazla toplu iğne başı büyüklüğünde delikler.</li>
        <li><strong>Akıntı:</strong> Çamaşırda fark edilen kirli sarı, bazen kanlı ve kötü kokulu nemlenme.</li>
        <li><strong>Ağrı ve Şişlik:</strong> Bölgede hassasiyet ve otururken zorlanma.</li>
        <li><strong>Apse Oluşumu:</strong> Bölgenin şişmesi, kızarması ve şiddetli zonklayıcı ağrı. <strong>Bu durum acil müdahale gerektirir.</strong></li>
      </ul>

      <h4>Neden Olur?</h4>
      <p>
        Hormonal değişimler nedeniyle kılların sertleşmesi, uzun süre oturmak (ders çalışma veya bilgisayar başı), 
        terleme ve sürtünme kılların cilt altına itilmesine neden olur.
      </p>

      <h4>Tedavi Yöntemleri</h4>
      <p>Tedavi, hastalığın evresine göre çocuk cerrahı tarafından belirlenir:</p>
      <ul>
        <li><strong>Kristalize Fenol Uygulaması:</strong> Deliklerden içeriye özel bir madde verilerek sinüsün kurutulmasıdır.</li>
        <li><strong>Lazer Tedavisi:</strong> Sinüs yolunun lazer enerjisiyle yakılarak kapatılmasıdır. İyileşme süreci çok hızlıdır.</li>
        <li><strong>Cerrahi Yöntemler (Ameliyat):</strong> Sinüsün tamamen çıkarılmasıdır. Tekrarlama riskini en aza indiren kesin çözüm yollarından biridir.</li>
      </ul>

      <div className="info-box" style={{ background: '#f0f9ff', padding: '15px', borderRadius: '12px', border: '1px solid #bae6fd', margin: '20px 0' }}>
        <p style={{ margin: 0, color: '#0369a1', fontWeight: '700' }}>Tekrarlamayı Önlemek İçin Altın Kurallar</p>
        <ul style={{ margin: '8px 0 0', color: '#0c4a6e', fontSize: '0.95rem' }}>
          <li><strong>Bölgesel Temizlik:</strong> Kuyruk sokumu bölgesi her gün yıkanmalı ve mutlaka kuru tutulmalıdır.</li>
          <li><strong>Kıl Temizliği:</strong> Ergenlikten itibaren o bölgedeki kıllar tüy dökücü krem veya lazer epilasyon ile temizlenmelidir.</li>
          <li><strong>Hareket:</strong> Uzun süre oturarak çalışılıyorsa sık sık ara verilmeli ve ayağa kalkılmalıdır.</li>
        </ul>
      </div>

      <div className="warning-box" style={{ backgroundColor: '#fffbe6', borderLeft: '5px solid #fadb14', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#856404', fontWeight: '800', marginBottom: '5px' }}>ÖNEMLİ NOT:</p>
        <p style={{ color: '#2d3748', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Kıl dönmesi kendi kendine iyileşen bir hastalık değildir; aksine tedavi edilmediğinde tüneller daha geniş 
          bir alana yayılabilir. Erken müdahale, ameliyatın büyüklüğünü ve iyileşme süresini azaltır.
        </p>
      </div>
    </div>
  )
},
   { 
  id: 23, 
  title: "Over (Yumurtalık) Kistleri", 
  icon: <Wind size={32} />, 
  color: "#4FC3F7", 
  longDesc: (
    <div className="treatment-details">
      <p>
        Yumurtalık kistleri, yumurtalık dokusu içinde gelişen sıvı dolu keseciklerdir. Çocuklarda ve özellikle 
        ergenlik dönemindeki genç kızlarda, hormon seviyelerinin değişmesiyle birlikte sıkça karşılaşılan bir durumdur.
      </p>

      <h4>Kist Tipleri ve Takip Süreci</h4>
      <ul>
        <li><strong>Fonksiyonel Kistler:</strong> En sık görülen türdür. Adet döngüsüyle ilişkili gelişirler. Genellikle 2-3 ay içinde kendiliğinden kaybolurlar; ultrason ile izlem yeterlidir.</li>
        <li><strong>Patolojik Kistler:</strong> Kendiliğinden geçme ihtimali olmayan, dermoid kist (teratom) gibi farklı dokular içeren türlerdir. Cerrahi müdahale gerektirebilirler.</li>
      </ul>

      <h4>Ne Zaman Cerrahi Planlanmalı?</h4>
      <p>Cerrahi kararı şu ana faktörlere göre verilir:</p>
      <ul>
        <li><strong>Boyut:</strong> Kistin çok büyük olması (5 cm ve üzeri) ve çevre organlara baskı yapması.</li>
        <li><strong>Karakter:</strong> Ultrason/MR görüntüsünde solid (katı) alanlar içermesi veya yapısının şüpheli durması.</li>
        <li><strong>Torsiyon Riski:</strong> Kistin kendi etrafında dönerek yumurtalığın kan akımını kesme riskinin bulunması.</li>
        <li><strong>Geçmeyen Kistler:</strong> Takip süresince küçülmeyen veya sürekli büyüyen kistler.</li>
      </ul>

      <h4>Ameliyat Yöntemi (Laparoskopi)</h4>
      <p>Günümüzde tercih edilen yöntem <strong>Laparoskopik (Kapalı) Cerrahi</strong>'dir.</p>
      <ul>
        <li><strong>Yumurtalık Koruyucu Cerrahi:</strong> Temel prensip, sadece kistin çıkarılması ve sağlıklı yumurtalık dokusunun maksimum düzeyde korunmasıdır.</li>
        <li><strong>Avantajlar:</strong> İyileşme çok hızlıdır, ağrı azdır ve estetik olarak neredeyse hiç iz kalmaz.</li>
      </ul>

      <div className="warning-box" style={{ backgroundColor: '#f0f9ff', borderLeft: '5px solid #0ea5e9', padding: '20px', marginTop: '25px', borderRadius: '15px' }}>
        <p style={{ color: '#0369a1', fontWeight: '800', marginBottom: '5px' }}>EBEVEYNLERE NOT:</p>
        <p style={{ color: '#1e293b', fontSize: '0.95rem', lineHeight: '1.6', margin: 0 }}>
          Her saptanan kist ameliyat gerektirmez. Önemli olan, kistin tipini doğru belirlemek ve 
          gereksiz müdahalelerden kaçınarak <strong>yumurtalık rezervini korumaktır.</strong>
        </p>
      </div>
    </div>
  )
},
  ];

  return (
    <div className="treatments-page">
      <Navbar />
      
      <section className="tr-hero-section">
        <div className="tr-hero-overlay"></div>
        <div className="container">
          <div className="tr-hero-content">
            <span className="tr-badge">UZMANLIK ALANLARI</span>
            <h1>Minik Kahramanlar İçin <span>Modern Cerrahi</span></h1>
            <p><DoctorName/> yönetiminde, akademik bilgi ve 30 yıllık cerrahi tecrübe ile çocuklarımızın yanındayız.</p>
          </div>
        </div>
      </section>

      <section className="tr-grid-container section-padding">
        <div className="container">
          <div className="tr-grid">
            {treatments.map((tr) => (
              <div 
                key={tr.id} 
                className="tr-card" 
                onClick={() => setSelectedTreatment(tr)}
                style={{ "--accent": tr.color }}
              >
                <div className="tr-card-blob"></div>
                <div className="tr-icon-box">{tr.icon}</div>
                <h3>{tr.title}</h3>
                <div className="read-more-btn">DETAYLI BİLGİ AL</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedTreatment && (
        <div className="modal-overlay" onClick={() => setSelectedTreatment(null)}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setSelectedTreatment(null)}><X size={24} /></button>
            <div className="modal-header" style={{ color: selectedTreatment.color }}>
              {selectedTreatment.icon}
              <h2>{selectedTreatment.title}</h2>
            </div>
            <div className="modal-body">
              {selectedTreatment.longDesc}
            </div>
            <div className="modal-footer">
              <button className="secondary-btn" onClick={() => setSelectedTreatment(null)}>Kapat</button>
              <button className="primary-btn">Hızlı İletişim</button>
            </div>
          </div>
        </div>
      )}

      <FooterSection />
      <QuickAccess />
    </div>
  );
};

export default TreatmentsPage;